module.exports = __webpack_public_path__ + "static/media/sleep-and-relaxation.61166963.png";